export default __webpack_public_path__ + "static/media/1391.f09123d1.png";